<template>
	<div>
		<Table :columns="columns1" :data="ChargeCards" style="width: 100%;"></Table>
	</div>
</template>

<script>
	// 限定场站列表	StationList
	// 限定场站列表	StationArray
	// 限定运营商列表	OperatorList
	// 限定运营商列表	OpeartorArray
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../../webapi'
	export default {
		props: {
			row: Object
		},
		data() {
			const _this = this;
			return {
				methodList: [{
						name: 'delete',
						Status: '注销'
					},
					{
						name: 'lost',
						Status: '挂失'
					},
					{
						name: 'unlock',
						Status: '解卦'
					},
					{
						name: 'lock',
						Status: '锁定'
					},
					{
						name: 'unlock',
						Status: '解锁'
					},
					{
						name: 'edit',
						Status: '修改'
				}],
				columns1: [{
						title: '序号',
						type: 'index',
						width: 60,
						align: 'center'
					}, {
						title: '建档时间',
						key: 'CreateTime',
						width: 160,
					}, {
						title: '充电卡号',
						key: 'CardNo',
						width: 150,
					}, {
						title: '会员ID',
						key: 'GroupId',
						width: 250,
					},
					// {
					// 	title: '会员名称',
					// 	key: 'GroupName',
					// 	width: 150,
					// 	// render: (h, params) => {
					// 	// 	return h('div', params.row.EquipmentTypeDesc)
					// 	// }
					// },
					// {
					// 	title: '车辆VIN',
					// 	key: 'CarVin',
					// 	width: 100,
					// },
					// {
					// 	title: '验证模式',
					// 	key: 'VerifyMode',
					// 	width: 100,
					// },
					// {
					// 	title: '限定运营商列表',
					// 	key: 'OperatorList',
					// 	width: 100,
					// },
					// {
					// 	title: '限定运营商列表',
					// 	key: 'OpeartorArray',
					// 	width: 100,
					// },
					// {
					// 	title: '账户余额',
					// 	key: 'Account',
					// 	width: 100
					// },
					// {
					// 	title: '累计充值金额',
					// 	key: 'RechargeAccount',
					// 	width: 100,
					// 	// render: (h, params) => {
					// 	// 	return h('div', params.row.StationName)
					// 	// }
					// },
					// {
					// 	title: '累计赠送金额',
					// 	key: 'GivenAccount',
					// 	width: 100,
					// },
					{
						title: '状态',
						key: 'State',
						width: 100,
						render: (h, params) => {
							return h('div', params.row.StateDesc)
						}
					},
					{
						title: '车牌号',
						key: 'CarNo',
						width: 100
					},
					{
						title: '可用场站',
						key: 'StationList',
						width: 200,
						render: (h, params) => {
							let station = ''

							for (let var1 of params.row.StationArray) {
								let stationName = _this.StationList.filter(function(item, index, arr) {

									return item.StationId == var1
								})[0].StationName
								station += stationName + ','
							}
							if (params.row.StationArray.length == 0) {
								station = '全部'
							}
							return h('div', station)
						}
					},
					// {
					// 	title: '限定场站列表',
					// 	key: 'StationArray',
					// 	width: 100,
					// },
					{
						title: '备注',
						key: 'Remark',
						width: 100,
					},
					// {
					// 	title: '创建人',
					// 	key: 'Creator',
					// 	width: 100,
					// },
					// {
					// 	title: '修改人',
					// 	key: 'Modifier',
					// 	width: 100,
					// },{
					// 	title: '修改时间',
					// 	key: 'ModifyTime',
					// 	width: 160,
					// },
					{
						title: '操作',
						key: 'action',
						width: 200,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								// h('Button', {
								// 	props: {
								// 		type: 'primary',
								// 		size: 'small'
								// 	},
								// 	style: {
								// 		marginRight: '5px'
								// 	},
								// 	on: {
								// 		click: () => {
								// 			this.$Modal.info({
								// 				title: '注销充电卡',
								// 				content: '<p>确定注销充电卡:' + params.row.CardNo + '</p>',
								// 				onOk: () => {
								// 					this.DeleteCard(params.row.GroupId, params.row.CardNo)
								// 				},
								// 				okText: '注销'
								// 			});
								// 			//this.$emit("DeleteCard",params.row.GroupId,params.row.CardNo)
								// 		}
								// 	}
								// }, '注销'),
								// h('Button', {
								// 	props: {
								// 		type: 'primary',
								// 		size: 'small'
								// 	},
								// 	style: {
								// 		marginRight: '5px'
								// 	},
								// 	on: {
								// 		click: () => {
								// 			this.$Modal.info({
								// 				title: '挂失充电卡',
								// 				content: '<p>确定挂失充电卡:' + params.row.CardNo + '</p>',
								// 				onOk: () => {
								// 					this.LostCard(params.row.GroupId, params.row.CardNo)
								// 				},
								// 				okText: '挂失'
								// 			});
								// 		}
								// 	}
								// }, '挂失'),
								// h('Button', {
								// 	props: {
								// 		type: 'primary',
								// 		size: 'small'
								// 	},
								// 	style: {
								// 		marginRight: '5px'
								// 	},
								// 	on: {
								// 		click: () => {
								// 			this.$Modal.info({
								// 				title: '解卦充电卡',
								// 				content: '<p>确定解卦充电卡:' + params.row.CardNo + '</p>',
								// 				onOk: () => {
								// 					this.UnLostCard(params.row.GroupId, params.row.CardNo)
								// 				},
								// 				okText: '解卦'
								// 			});
								// 		}
								// 	}
								// }, '解挂'),
								// h('Button', {
								// 	props: {
								// 		type: 'primary',
								// 		size: 'small'
								// 	},
								// 	style: {
								// 		marginRight: '5px'
								// 	},
								// 	on: {
								// 		click: () => {
								// 			this.$Modal.info({
								// 				title: '锁定充电卡',
								// 				content: '<p>确定锁定充电卡:' + params.row.CardNo + '</p>',
								// 				onOk: () => {
								// 					this.LockCard(params.row.GroupId, params.row.CardNo)
								// 				},
								// 				okText: '锁定'
								// 			});
								// 		}
								// 	}
								// }, '锁定'),
								// h('Button', {
								// 	props: {
								// 		type: 'primary',
								// 		size: 'small'
								// 	},
								// 	style: {
								// 		marginRight: '5px'
								// 	},
								// 	on: {
								// 		click: () => {
								// 			this.$Modal.info({
								// 				title: '解锁充电卡',
								// 				content: '<p>确定解锁充电卡:' + params.row.CardNo + '</p>',
								// 				onOk: () => {
								// 					this.UnLockCard(params.row.GroupId, params.row.CardNo)
								// 				},
								// 				okText: '解锁'
								// 			});
								// 		}
								// 	}
								// }, '解锁'),
								// h('Button', {
								// 	props: {
								// 		type: 'primary',
								// 		size: 'small'
								// 	},
								// 	style: {
								// 		marginRight: '5px'
								// 	},
								// 	on: {
								// 		click: () => {
								// 			this.openRechargeForCard(params.row.GroupId, params.row.CardNo)
								// 		}
								// 	}
								// }, '充值'),
								this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h('Dropdown', {
										on: {
											//为了不误操作，确定取消相反
											'on-click': (name) => {
												if (name == '修改') {
													this.otherMethod(name, params.row.GroupId, params
														.row.CardNo);
												} else {
													this.$Modal.confirm({
														title: name,
														okText: '取消',
														cancelText: '确定',
														onCancel: () => {
															this.otherMethod(name, params
																.row.GroupId, params
																.row.CardNo);
														}
													});
												}
												// this.show("deleteStation", params.row.Id)
											}
										},
										props: {
											transfer: true,
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, '电卡操作'),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.filter(item => this.hasWidgets(item.name)).map((
												item) => { // this.productTypeList下拉框里的data
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								) : h()
							]);
						}
					}
				],
				//设备信息中的枪信息列表
				ChargeCards: this.row.ChargeCards,
			}
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//删除修改之外的其他操作
			otherMethod: function(type, GroupId, CardNo) {
				switch (type) {
					case "注销":
						this.DeleteCard(GroupId, CardNo)
						break;
					case "挂失":
						this.LostCard(GroupId, CardNo)
						break;
					case "解卦":
						this.UnLostCard(GroupId, CardNo)
						break;
					case "锁定":
						this.LockCard(GroupId, CardNo)
						break;
					case "解锁":
						this.UnLockCard(GroupId, CardNo)
						break;
					case "修改":
						this.$emit("upCard", GroupId, CardNo)
						break;
				}
			},
			//卡注销
			DeleteCard: function(GroupId, CardNo) {
				const _this = this;
				let parms = {
					GroupId: GroupId,
					CardNo: CardNo
				};
				_this.$axios.post(webapi.base_api_url + "/Member/DeleteChargeCard", parms, {}).then(res => {
					console.log("注销卡")
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success('注销卡成功');
						_this.$emit("upData")
					} else {
						this.$Message.error('注销卡失败');
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			LostCard: function(GroupId, CardNo) {
				const _this = this;
				let parms = {
					GroupId: GroupId,
					CardNo: CardNo
				};
				_this.$axios.post(webapi.base_api_url + "/Member/LostCard", parms, {}).then(res => {
					console.log("挂失卡")
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success('挂失卡成功');
						_this.$emit("upData")
					} else {
						this.$Message.error('挂失卡失败');
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			//解卦
			UnLostCard: function(GroupId, CardNo) {
				const _this = this;
				let parms = {
					GroupId: GroupId,
					CardNo: CardNo
				};
				_this.$axios.post(webapi.base_api_url + "/Member/UnLostCard", parms, {}).then(res => {
					console.log("解卦卡")
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success('解卦卡成功');
						_this.$emit("upData")
					} else {
						this.$Message.error('解卦卡失败');
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			//锁定
			LockCard: function(GroupId, CardNo) {
				const _this = this;
				let parms = {
					GroupId: GroupId,
					CardNo: CardNo
				};
				_this.$axios.post(webapi.base_api_url + "/Member/LockCard", parms, {}).then(res => {
					console.log("锁定卡")
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success('锁定卡成功');
						_this.$emit("upData")
					} else {
						this.$Message.error('锁定卡失败');
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			//解锁
			UnLockCard: function(GroupId, CardNo) {
				const _this = this;
				let parms = {
					GroupId: GroupId,
					CardNo: CardNo
				};
				_this.$axios.post(webapi.base_api_url + "/Member/UnLockCard", parms, {}).then(res => {
					console.log("解锁卡")
					console.log(res.data)
					if (res.data.Code == 0) {
						this.$Message.success('解锁卡成功');
						_this.$emit("upData")
					} else {
						this.$Message.error('解锁卡失败');
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
		}
	}
</script>

<style>
</style>
